<ion-app>
    <!-- Auth Transition Loader - shown during logout or post-login transition -->
    @if ((isLogoutLoading$ | async) || (isAuthTransitionLoading$ | async)) {
        <app-loading-container 
            [fullscreen]="true">
        </app-loading-container>
    }

    <!-- Main Content -->
    <ion-content>
        <div class="app-root-container" 
             [class.logged-in]="isLoggedIn$ | async"
             [class.hidden]="(isLogoutLoading$ | async) || (isAuthTransitionLoading$ | async)">
            <!-- Sidenav -->
            <app-sidenav [isOpen]="isSidenavOpen()" (toggleSidenav)="toggleSidenav()" (closeSidenav)="closeSidenav()">
            </app-sidenav>

            <div class="content">
                <!-- Global Header - only show for authenticated users on non-public routes -->
                @if ((isAuthenticated$ | async) && !(isPublicRoute$ | async)) {
                    <div class="global-header">
                        <app-control-header></app-control-header>
                    </div>
                }

                <div class="content-router">
                    <div class="scrollable-content">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>

            <!-- Global Avatar Box -->
            <!-- CRITICAL: Component is always in DOM to preserve Simli WebRTC connection during navigation -->
            <!-- Use CSS visibility instead of *ngIf to prevent component destruction -->
            @if (avatarBoxState$ | async; as avatarBoxState) {
                <div class="global-avatar-container"
                    [class.fullscreen-mode]="(avatarBoxMode$ | async) === 'fullscreen'"
                    [class.minimized-mode]="(avatarBoxMode$ | async) === 'minimized'"
                    [class.hidden-mode]="(avatarBoxMode$ | async) === 'hidden'"
                    [class.should-show]="avatarBoxState.shouldShow"
                    (click)="onAvatarContainerClick()">

                    <app-avatar-box></app-avatar-box>
                </div>
            }
        </div>
    </ion-content>
</ion-app>